import {Platform} from 'react-native';
import {differenceInDays, endOfMonth} from 'date-fns';

import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {openURL, openURLInNewTabOnWeb} from '/util/linking.util';

export const getEarnedBonusAmount = ({
  newOrderingEntities,
  maxAmount,
  intermediateAmount,
}: {
  newOrderingEntities: number;
  maxAmount: number;
  intermediateAmount: number;
}): number => {
  if (newOrderingEntities >= 5) {
    return maxAmount;
  } else if (newOrderingEntities >= 3) {
    return intermediateAmount;
  }
  return 0;
};

export function getDaysLeftForBonus({
  currentDate,
}: {
  currentDate: string | Date;
}) {
  const endOfCurrentMonth = endOfMonth(new Date(currentDate));
  return differenceInDays(endOfCurrentMonth, new Date(currentDate));
}

export const maxCSB = '+5%';
export const intemidiateCSB = '+3%';
export const intemidiateCSBValue = '+3% FCV';

type EarnedCSBAmountParams = {
  newOrderingEntities: number;
};

export const getEarnedCSBAmount = ({
  newOrderingEntities,
}: EarnedCSBAmountParams): string => {
  if (newOrderingEntities >= 5) {
    return maxCSB;
  } else if (newOrderingEntities >= 3) {
    return intemidiateCSB;
  }
  return '+0%';
};

export const maximumCSB = '+7%';
export const lowerIntermidiateCSB = '+3%';
export const higherIntermidiateCSB = '+5%';

type UpdatedEarnedCSBAmountParams = {
  newOrderingEntities: number;
  newOECount?: number;
};

export const getUpdatedEarnedCSBAmount = ({
  newOrderingEntities,
  newOECount,
}: UpdatedEarnedCSBAmountParams) => {
  // Check if newOECount is less than 2
  if (typeof newOECount === 'number' && newOECount < 2) {
    return '+0%';
  }
  if (newOrderingEntities >= 7) {
    return maximumCSB;
  } else if (newOrderingEntities >= 2 && newOrderingEntities <= 4) {
    return lowerIntermidiateCSB;
  } else if (newOrderingEntities >= 5 && newOrderingEntities <= 6) {
    return higherIntermidiateCSB;
  }
  return '+0%';
};

export const maximumCSBV5 = '+10%';
export const lowerIntermidiateCSBV5 = '+3%';
export const higherIntermidiateCSBV5 = '+5%';
export const midIntermidiateCSBV5 = '+7%';

type EarnedCSBParams = {
  newOrderingEntities: number;
};

export const getUpdatedEarnedCSBV5Amount = ({
  newOrderingEntities,
}: EarnedCSBParams): string => {
  if (newOrderingEntities >= 10) {
    return maximumCSBV5;
  } else if (newOrderingEntities >= 7) {
    return midIntermidiateCSBV5;
  } else if (newOrderingEntities >= 5) {
    return higherIntermidiateCSBV5;
  } else if (newOrderingEntities >= 3) {
    return lowerIntermidiateCSBV5;
  }
  return '+0%';
};

export const generateOnLearnMoreCSB = (
  {popoverShow}: any,
  currentScreen: any,
  url: any,
) => {
  return () => {
    if (currentScreen === 'Dashboard' && Platform.OS === 'web') {
      openURLInNewTabOnWeb(url);
      return;
    }

    popoverShow(VisitWebsitePopover, {
      currentScreen: currentScreen,
      onSubmit: () => openURL('url', url),
    });
  };
};
